<template>

  <el-row>
    <el-col :span="24" class="component-container">
      <div class="box-component">

        <el-row style="justify-content: center; font-size: 1.25rem; margin-bottom: 1.5rem;">
          <p class="fat-text">
            Budjettilaskuri
          </p>
        </el-row>

        <el-row class="dropdown-row">
          <p class="no-margin">
            Rakennuksen kerrosluku:
          </p>

          <el-select v-model="budgetValues[0]" placeholder="Vaihtoehdot" @change="selectChange">
            <el-option
              v-for="item in options[0]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-row>

        <el-row class="dropdown-row">
          <p class="no-margin">
            Kattorakennetyyppi:
          </p>
          <el-select v-model="budgetValues[1]" placeholder="Vaihtoehdot" @change="selectChange">
            <el-option
              v-for="item in options[1]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-row>

        <el-row class="dropdown-row">
          <p class="no-margin">
            Aurinkovoimalan liitynnän sijainti sähkökeskukseen:
          </p>
          <el-select v-model="budgetValues[2]" placeholder="Vaihtoehdot" @change="selectChange">
            <el-option
              v-for="item in options[2]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-row>

        <el-row class="dropdown-row">
          <p class="no-margin">
            Vapaita sulakepaikkoja sähkökeskuksessa:
          </p>
          <el-select v-model="budgetValues[3]" placeholder="Vaihtoehdot" @change="selectChange">
            <el-option
              v-for="item in options[3]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-row>

        <el-row class="dropdown-row">
          <p class="no-margin">
            Monenko rakennuksen katolle voimala on tulossa:
          </p>
          <el-input-number min="1" max="10" v-model="num" placeholder="1" @change="selectChange"/>
        </el-row>

      </div>
    </el-col>
  </el-row>
    <!--
    <el-row>
      <el-col :span="24" class="component-container">
        <div class="box-component">

          <el-row>
            <el-col :span="8" class="data-item" style="margin-bottom: 0">
              <span>Hinta</span>
              <p>
                <img class="data-icon" src="/src/assets/icons/icon-money.svg" />
                <span v-if="budget[1] === 1">{{ props.calculatedPrice[1]+budget[0] }}  €</span><span v-else>-</span>
              </p>
              <span>ALV0%</span>
            </el-col>

            <el-col :span="8" class="data-item" style="margin-bottom: 0">
              <span>€/paneeli</span>
              <p>
                <img class="data-icon" src="/src/assets/icons/icon-money.svg" />
                <span v-if="budget[1] === 1">{{ ((props.calculatedPrice[1]+budget[0])/props.calculationData.modules).toFixed(0) }} €</span><span v-else>-</span>
              </p>
              <span>ALV0%</span>
            </el-col>

            <el-col :span="8" class="data-item" style="margin-bottom: 0">
              <span>€/kW</span>
              <p>
                <img class="data-icon" src="/src/assets/icons/icon-money.svg" />
                <span v-if="budget[1] === 1">{{ (Math.round((props.calculatedPrice[1]+budget[0])/props.calculationData.modulePower)/1000).toFixed(2) }} €</span><span v-else>-</span>
              </p>
              <span>ALV0%</span>
            </el-col>

          </el-row>
          <el-row>
            <div style="margin-top: 2rem; font-size: 13px;">
              <p>Laskurin antaman hinnat ovat kaikilta osin alustavia eivät sido osapuolia millään tavalla. Sitovan hintatarjouksen saat jättämällä yhteystietosi tämän laskurin kautta tai ottamalla yhteyttä Naps-myyntiin</p>
            </div>
          </el-row>
        </div>
      </el-col>
    </el-row>
    -->
    <el-row>
      <el-col :span="24" class="component-container">
        <div class="box-component">

         <p class="fat-text" style="font-size: 18px">Hinta sisältää seuraavat komponentit avaimet käteen asennettuna</p>
          <ul>
            <li>- Aurinkopaneelit (Jinko tai Trina tai vastaava teholtaan 425W paneeli)</li><br>
            <li>- Kattoasennusmekaniikan tasakatolle</li><br>
            <li>- Vaihtosuuntaajan (Growatt tai vastaava kokoluokan mukaan)</li><br>
            <li>- AC-kytkimen</li><br>
            <li>- DC-kaapelit ja -liittimet, turvatarrat ja käyttöohjeet</li><br>
          </ul>
          <p>Mikäli Teillä on tarve suuremmalle kuin 22kWp suuruiselle aurinkovoimalalle, niin ota yhteyttä Naps-myyntiin. Laskemme Teille tarjouksen projektikohtaisesti.</p>
        </div>
      </el-col>
    </el-row>

  </template>

  <script lang="ts" setup>

  import { ref } from "vue";
  import type { CalculationData } from "@/types";

  const emit = defineEmits(["emitBudget"]);

  const props = defineProps<{
    calculatedPrice: number[];
    calculationData: CalculationData;
    budgetValues: number[]|string[];
    numberOfRoofs: number;
  }>();

  const num = ref<number>(1);
  num.value = props.numberOfRoofs;

  const options = [
    [
      {
        value: 0,
        label: '1-3 kerrosta',
      },
      {
        value: 1000,
        label: '4 ja enemmän',
      },
    ],
    [
      {
        value: 0,
        label: 'Tasakatto',
      },
      {
        value: 2000,
        label: 'Harjakatto',
      },
    ],
    [
      {
        value: 0,
        label: 'Katolla',
      },
      {
        value: 5000,
        label: 'Kellarissa',
      },
    ],
    [
      {
        value: 0,
        label: 'Kyllä',
      },
      {
        value: 1000,
        label: 'Ei / en tiedä',
      },
    ],
  ];
  const budget = ref([0,0]);

  function selectChange() {
    const values = props.budgetValues;
    let selected = 0;
    let b = 0;
    values.forEach((x:number|string) => {
      if (typeof x === "number") {
        b += x;
        selected += 1;
      }
    });

    if (num.value > 1) {
      b += (num.value-1)*2000
    }

    budget.value = [b,selected/values.length];

    emit("emitBudget", [budget.value, num.value]);

  }

  // Run this function once when stage is reloded. Incase use goes back after inserting values once.
  selectChange();

  </script>
